<template>
  <div>
    <div class="row">
      <div class="col-md-12 text-right">
        <v-btn
          @click="$bvModal.show('filter')"
          class="btn-filter mr-2"
          type="relief"
        >
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
        </v-btn>
        <v-btn
          v-if="permission('write', 'resident_hosting')"
          @click="$bvModal.show('new_hosting')"
          class="btn-two-add"
        >
          <i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR HOSPEDAGEM
        </v-btn>
      </div>
      <div class="col-md-12">
        <ErrorsMessages :errors="errors" />
        <b-overlay :show="loading" opacity="0.99"> </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import routes from "../../../../routes";

import { professionalClassCouncilValue } from "../../../../lib/format";

import moment from "moment";

import permission from "../../../../lib/permission";

export default {
  name: "Hosting",

  components: {
    ErrorsMessages,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      resident_id: "",

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    professionalClassCouncilValue,
    permission,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;
    },
  },
};
</script>
